import React from "react";
import styles from "./styles.module.scss";

interface ButtonTextProps {
    onChange?: () => void;
    isLoading?: boolean;
    isDisabled?: boolean;
    children?: React.ReactNode;
}

const ButtonText: React.FC<ButtonTextProps> = ({
                                           onChange = () => {},
                                           isLoading = false,
                                           isDisabled = false,
                                           children = "Continue",
                                       }) => {
    return (
        <button
            className={`${styles.button} ${isDisabled ? styles.disabled : ""} ${
                isLoading ? styles.loading : ""
            }`}
            onClick={onChange}
            disabled={isDisabled || isLoading}
        >
            {isLoading ? (
                <div className={styles.spinner}></div>
            ) : (
                children
            )}
        </button>
    );
};

export default ButtonText;